
export { ShoppingBagButton } from "/codebuild/output/src1614243332/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"